import { render } from "./Questions.vue?vue&type=template&id=21a6023f"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
script.render = render

export default script